class CraftedBannerSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initMainSlider();
  }

  initMainSlider() {
    new Swiper(this.querySelector('.crafted-banner-main-slider'), {
      slidesPerView: 1.5,
      centeredSlides: true,
      loop: true,
      allowTouchMove: false,
      spaceBetween: 10,
      
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        320: {
            slidesPerView: 1.2,
            spaceBetween: 10,
            allowTouchMove: true,
        },
        768: {
            slidesPerView: 1.2,
            spaceBetween: 16,
            allowTouchMove: false,
        },
        1024: {
            slidesPerView: 1.5,
            spaceBetween: 10
        },
        2880: {
            slidesPerView: 3.5,
            spaceBetween: 10
        }
      }
    });
  }
}

customElements.define('crafted-banner-slider', CraftedBannerSlider);